import React from 'react'
import './index.css'
import { ReactComponent as Close } from '../../res/img/close.svg'

const BackHeader = (props) => {
  const { onBack } = props
  const onClickBack = () => {
    onBack()
  }
  return <Close onClick={onClickBack} className={'back-header'} />
}

export default BackHeader
